import React from 'react';
import { Icon } from 'antd'
import './info-card.css';

export default ({ value = 0, name, className, sync = false }) => (
  <div className={`info-card ${className ? className : ''}`}>
    {!sync && value !== undefined ? <div className='info-value'>{value}</div> : <Icon type='sync' className="icon-value" spin={true} />}
    <div className='info-name'>{name}</div>
  </div>
)


// WEBPACK FOOTER //
// ./src/App/components/info-card/info-card.js